define.alias("shared/components/shared/feature-upgrade-banner", "preview-grid/components/shared/feature-upgrade-banner");